import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { propTypes } from '../../util/types';
import {
  ExternalLink,
  InlineTextButton,
  NamedLink,
  NotificationBadge
} from '../../components';

import css from './TopbarMenu.css';
import config from '../../config';

const TopbarMenu = props => {
  const {
    isAuthenticated,
    currentUserHasListings,
    messagesNotificationCount,
    bookingsNotificationCount,
    onLogout,
  } = props;
  const [isFirstRender, setIsFirstRender] = useState(true);
  useEffect(() => {
    if (!isFirstRender) return null;

    setIsFirstRender(false);
  },[] );
  if (isFirstRender) return null;

  const messageNotificationDot = messagesNotificationCount > 0 &&
    <NotificationBadge count={messagesNotificationCount} />;
  const bookingsNotificationDot = bookingsNotificationCount > 0 &&
    <NotificationBadge count={bookingsNotificationCount} />;

  return (
    <div className={css.container}>
      {isAuthenticated ? (
        <Fragment>
          <section className={css.sectionMainActions}>
            <NamedLink name="LandingPage" className={css.mainAction}>
              <FormattedMessage id="TopbarMenu.findAPool"/>
            </NamedLink>
            <NamedLink name="NewListingPage" className={css.mainAction}>
              <FormattedMessage id="TopbarMenu.rentMyPool"/>
            </NamedLink>
          </section>
          <div className={css.separator} />
          <section className={css.sectionOther}>
            <NamedLink name="AccountSettingsPage" className={css.other}>
              <FormattedMessage id="TopbarMenu.accountSettingsLink"/>
            </NamedLink>
            <NamedLink
              name="InboxPage"
              className={css.other}
            >
              <FormattedMessage id="TopbarMenu.messagesLink"/>
              {messageNotificationDot}
            </NamedLink>
            <NamedLink
              name="ReservationsPage"
              className={css.other}
              params={{ tab: 'pending' }}
            >
              <FormattedMessage id="TopbarMenu.inboxLink"/>
              {bookingsNotificationDot}
            </NamedLink>
            {currentUserHasListings ? (
              <Fragment>
                <NamedLink name="ManageListingsPage" className={css.other}>
                  <FormattedMessage id="TopbarMenu.listingsLink"/>
                </NamedLink>
                <NamedLink name="IncomePage" className={css.other}>
                  <FormattedMessage id="TopbarMenu.incomeLink"/>
                </NamedLink>
              </Fragment>
            ) : null}
            <ExternalLink href={config.custom.helpCenterUrl} openInSameWindow className={css.other}>
              <FormattedMessage id="TopbarMenu.helpdeskLink"/>
            </ExternalLink>
            <NamedLink name="MyFavoritesPage" className={css.other}>
              <FormattedMessage id="TopbarMenu.myFavoritesLink"/>
            </NamedLink>
            <ExternalLink href="https://blog.swimmy.fr/" className={css.other}>
              <FormattedMessage id="TopbarMenu.blog"/>
            </ExternalLink>
          </section>
          <InlineTextButton className={css.logout} onClick={onLogout}>
            <FormattedMessage id="TopbarMenu.logout" />
          </InlineTextButton>
        </Fragment>
      ) : (
        <Fragment>
          <section className={css.sectionMainActions}>
            <NamedLink name="LandingPage" className={css.mainAction}>
              <FormattedMessage id="TopbarMenu.findAPool"/>
            </NamedLink>
            <NamedLink name="SimulatorPage" className={css.mainAction}>
              <FormattedMessage id="TopbarMenu.rentMyPool"/>
            </NamedLink>
          </section>
          <div className={css.separator} />
          <section className={css.sectionOther}>
            <NamedLink name="LoginPage" className={css.other}>
              <FormattedMessage id="TopbarMenu.loginLink"/>
            </NamedLink>
            <NamedLink name="SignupPage" className={css.other}>
              <FormattedMessage id="TopbarMenu.signupLink"/>
            </NamedLink>
            <ExternalLink href={config.custom.helpCenterUrl} openInSameWindow className={css.other}>
              <FormattedMessage id="TopbarMenu.helpdeskLink"/>
            </ExternalLink>
            <ExternalLink href="https://blog.swimmy.fr/" className={css.other}>
              <FormattedMessage id="TopbarMenu.blog"/>
            </ExternalLink>
          </section>
        </Fragment>
      )}
    </div>
  );
};

TopbarMenu.defaultProps = {
  currentUser: null,
  messagesNotificationCount: 0,
  bookingsNotificationCount: 0,
  currentPage: null };

const { bool, func, number, string } = PropTypes;

TopbarMenu.propTypes = {
  isAuthenticated: bool.isRequired,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  messagesNotificationCount: number,
  bookingsNotificationCount: number,
  onLogout: func.isRequired,
};

export default TopbarMenu;



// WEBPACK FOOTER //
// ./src/components/TopbarMenu/TopbarMenu.js